import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { SimpleDateField, Icon } from '@jutro/components';
import NfumFieldLabel from '../NfumFieldLabel/NfumFieldLabel';
import styles from './NfumSimpleDateField.module.scss';

function NfumSimpleDateField(props) {
    const {
        value,
        success,
        error,
        onValidationChange,
        className,
        onBlur,
        legend
    } = props;
    const [currentValidation, updateCurrentValidation] = useState(true);
    const [showState, updateShowState] = useState(false);
    const simpleDateFieldContainerRef = useRef();
    const showError = error || !currentValidation;
    let icon;

    /**
     * #834144 Added to remove "NaN" text in input fields when entering string in android
     */
    const twoDigits = document.getElementsByClassName('jut__InputField__input jut__SimpleDateField__twoDigits');
    const fourDigits = document.getElementsByClassName('jut__InputField__input jut__SimpleDateField__fourDigits');
    Array.from(twoDigits).forEach((digit) => {
        digit.setAttribute('type', 'number');
    });

    Array.from(fourDigits).forEach((digit) => {
        digit.setAttribute('type', 'number');
    });

    if (showError) {
        icon = 'gw-close';
    } else if (success || value) {
        icon = 'gw-check';
    } else {
        icon = undefined;
    }
    const iconClass = classNames(styles.nfumInputIcon, {
        [styles.errorIcon]: showError
    });

    const iconComponent = <Icon icon={icon} className={iconClass} />;
    const inputClass = classNames(
        styles.nfumInputField,
        className,
        showState && showError && styles.errored
    );

    /* nfum patch - placeholder attribute is not working in GW SimpleDateField component */
    useEffect(() => {
        const monthInput = simpleDateFieldContainerRef.current.querySelector('[placeholder="MM"]');
        monthInput.setAttribute('placeholder', 'm m');
        monthInput.classList.add('mmStyle');
    }, []);

    const onValidate = (isValid, path) => {
        updateCurrentValidation(isValid);
        onValidationChange(isValid, path);
    };

    const handleBlur = (event, data) => {
        if (onBlur) {
            onBlur(data.value, data.model);
        }
        if (data.value) {
            updateShowState(true);
        }
    };

    return (
        <fieldset className={styles.nfumInputContainer}>
            { legend && <legend>{legend}</legend>}
            <NfumFieldLabel
                {...props}
            />
            <div className={styles.nfumInput} ref={simpleDateFieldContainerRef}>
                <SimpleDateField
                    {...props}
                    className={inputClass}
                    onValidationChange={onValidate}
                    onBlur={handleBlur}
                    hideLabel="true"
                    role="group"
                    aria-labelledby="date-label"
                />
                {(showState) && iconComponent}
            </div>
        </fieldset>
    );
}

export default NfumSimpleDateField;
